module.exports = __webpack_public_path__ + "img/sixpackcarrier09.17210ca4.jpg";